/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {enqueueCashInRequirements} from '../api'

export const useMutationEnqueueCashInRequirements = createReactQueryMutationHook('enqueueCashInRequirements', enqueueCashInRequirements)
